export default __webpack_public_path__ + "static/media/logoTimescope.aec1b0f3.svg";